import BellNotificationIcon from "@shared/svg/bell-notification.svg?react";
import WarningIcon from "@shared/svg/warning.svg?react";
import Label, { LABEL_SIZES } from "@shared/ui/Label";
import moment from "moment-timezone";
import React from "react";
import { useIntl } from "react-intl";

import { UserType } from "#/src/types/user";
import { useAuth } from "~/components/general";

export const DueDateTag = ({ dueDate, isClosedTicket, className }) => {
  const { messages } = useIntl();
  const { user } = useAuth() as { user: UserType };
  const dateFormat = user.dateFormat || "YYYY-MM-DD";

  const dueDateFormatted = dueDate ? moment(dueDate).format(dateFormat) : "";

  const isDueDateUpcoming = dueDate && moment(dueDate).isAfter(moment(), "day");
  const isDueDateToday = dueDate && moment(dueDate).isSame(moment(), "day");
  const isDueDateTomorrow =
    dueDate && moment(dueDate).isSame(moment().add(1, "day"), "day");

  const daysLeft = dueDate ? moment(dueDate).diff(moment(), "days") + 1 : 0;

  const isDueDateMoreThanThreeDaysAway = daysLeft > 3;

  const dueDateTitle = isDueDateToday
    ? messages["tickets"]["today"]
    : isDueDateTomorrow
    ? messages["tickets"]["tomorrow"]
    : isDueDateUpcoming
    ? `${daysLeft} ${messages["tickets"]["daysLeft"]}`
    : messages["tickets"]["overdue"];

  const dueDateHoverText =
    isDueDateUpcoming || isDueDateToday
      ? messages["tickets"]["dueDate"] + ": " + dueDateFormatted
      : messages["tickets"]["overdueSince"] + ": " + dueDateFormatted;

  const dueDateContentColor = isDueDateMoreThanThreeDaysAway
    ? "text-secondary"
    : "text-danger";
  const dueDateBackgroundColor = isDueDateMoreThanThreeDaysAway
    ? "bg-accent"
    : "bg-danger-lightest";

  const dueDateIcon = isDueDateUpcoming ? (
    <BellNotificationIcon
      className={`${dueDateContentColor} w-[12px] h-[12px] stroke-[2]`}
    />
  ) : (
    <WarningIcon
      className={`${dueDateContentColor} w-[12px] h-[12px] stroke-[2]`}
    />
  );

  return (
    <div>
      {dueDate && !isClosedTicket && (
        <div
          className={className}
          data-tip={dueDateHoverText}
          data-for="global-tooltip"
          data-event="mouseenter"
          data-event-off="mouseleave"
        >
          <Label
            size={LABEL_SIZES.SMALL}
            color={dueDateContentColor}
            className={`text-xs font-bold ${dueDateContentColor} ${dueDateBackgroundColor} py-2xs px-xs rounded-md flex items-center group-hover:bg-warning group-hover:text-white`}
          >
            <span className="mr-2xs leading-none">{dueDateIcon}</span>
            {dueDateTitle}
          </Label>
        </div>
      )}
    </div>
  );
};
